import { createSelector } from 'reselect';
import {
    statsTypeSelector,
    seasonSelector,
    roundSelector,
    statsLeadersNavSelector
} from '.';

/**
 * Checks whether we have the information necessary to perform the fetch to
 * retrieve the correct stats.
 *
 * @returns {( object ) => boolean} True if ready to fetch, otherwise false.
 */
export const isReadyToFetchSelector = createSelector(
    statsTypeSelector,
    seasonSelector,
    roundSelector,
    statsLeadersNavSelector,
    (statsType, season, round, nav) => {
        if (nav.round.id === null) {
            return false;
        }

        if (!nav.season) {
            return false;
        }

        switch (statsType) {
            case 'seasons':
                return !!season?.providerId;
            case 'rounds':
                return !!round?.providerId;
            case 'unknown':
            default:
                return false;
        }
    }
);
